import React from 'react';
import type { ComponentProps } from 'react';
import styled from '@emotion/styled';
import { color, display, height, left, position, right } from 'styled-system';

const SECTION_POSITION = ['-16px', '-24px', '-48px', '-64px'];

const UnstyledBorder = styled.div<any>`
  ${height};
  ${position};
  ${color};
  ${display};
  ${left};
  ${right};
`;

const Border = (props: ComponentProps<typeof UnstyledBorder>) => (
  <UnstyledBorder
    position="absolute"
    height="1px"
    bg="sys.neutral.border.weak"
    display="block"
    left={SECTION_POSITION}
    right={SECTION_POSITION}
    {...props}
  />
);

export default Border;
